import React from 'react'
import { integrationKeyByType } from '../../../types/integrationTypeUtils'
import { appRoutes } from '../../../common/appRoutes'
import { useLogic, useStore } from '../../../hooks/storeHook'
import { useHistory } from 'react-router-dom'
import { useMessages } from '../../../hooks/snackbarHooks'
import { IntegrationType } from '../../../server/mpsklad_core/Entity/IntegrationType'
import { DeleteIcon } from '../../shared/ui/icons'
import { createStyles, makeStyles } from '@material-ui/core/styles'

interface AccountDeleteButtonProps {
  accountId: number

  integrationType: IntegrationType
}

export const AccountDeleteButton = ({accountId, integrationType}: AccountDeleteButtonProps) => {
  const logic = useLogic()

  const {setHomeNav} = useStore()

  const history = useHistory()

  const {showSuccess, showError} = useMessages()

  const classes = useStyles()

  const onDeleteAccount = async (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()

    try {

      const isSuccess = await logic.showDialog(
        'Удалённый аккаунт невозможно восстановить!', {title: 'Удалить аккаунт?', acceptButton: 'Удалить'})

      if (!isSuccess) {
        return
      }

      await logic.deleteAccount(accountId, integrationType)

      const integrationTypeKey = integrationKeyByType[integrationType]

      history.push(appRoutes.Store.settings.api.makeUrl({accountId: 0, integration: integrationTypeKey}))

      setHomeNav(integrationType, undefined)

      showSuccess('Аккаунт удален!')
    } catch (error) {
      console.error('Failed to delete account', error)
      showError('Произошла ошибка во время удаления аккаунта...')
    }
  }

  return <div onClick={onDeleteAccount} className={classes.imgWrapper}>
    <DeleteIcon/>
  </div>
}

const useStyles =
  makeStyles(() =>
    createStyles({
      imgWrapper: {
        height: '12px',
        color: '#727272',
        transition: 'all .3s ease',
        '&:hover': {
          color: 'red',
          opacity: 0.8
        }
      }
    }))